export default {
  setRoles (state, roles) {
    state.roles = roles
  },
}
